import * as React from 'react';
import * as styles from './styles.css';

import { Text } from '../Text';
import { Container } from '../Container';
import { NBSP } from '../../constants/symbols';

import cup from './icons/cup.svg';
import mail from './icons/mail.svg';
import userCard from './icons/userCard.svg';

export function BigResource() {
  return (
    <div className={styles['container']}>
      <Container>
        <div className={styles['title']}>
          <Text size="h2" bold>
            Циан - крупнейший ресурс о{NBSP}недвижимости{' '}
            <span>
              <Text color="gray" size="h4" bold>
                <sup>1</sup>
              </Text>
            </span>
          </Text>{' '}
        </div>
        <div className={styles['description']}>
          <Text>
            Мы сотрудничаем со всеми известными компаниями на рынке недвижимости, включая 3{NBSP}100{NBSP}застройщиков,
            30{NBSP}000{NBSP}агентств недвижимости и{NBSP}250{NBSP}000{NBSP}риелторов и агентств
          </Text>
        </div>
        <div className={styles['items']}>
          <div className={styles['item']}>
            <img className={styles['image']} src={cup} alt="" />
            <div>
              <Text size="h1" block>
                9 место
              </Text>
              <Text block>В мире по версии SimilarWeb среди сервисов о{NBSP}недвижимости</Text>
            </div>
          </div>
          <div className={styles['item']}>
            <img className={styles['image']} src={mail} alt="" />
            <div>
              <Text size="h1" block>
                2 500 000
              </Text>
              <Text block>Объявлений по всей стране</Text>
            </div>
          </div>
          <div className={styles['item']}>
            <img className={styles['image']} src={userCard} alt="" />
            <div>
              <Text size="h1" block>
                14 300 000
              </Text>
              <Text block>Уникальных пользователей в{NBSP}месяц</Text>
            </div>
          </div>
        </div>
        <div className={styles['note']}>
          <Text size="verySmall" color="gray">
            <sup>1</sup> По количеству размещенных активных объявлений по всей России во всех категориях по состоянию на
            июнь 2018 года по{NBSP}данным исследования независимого агентства МАСМИ
          </Text>
        </div>
      </Container>
    </div>
  );
}
